<input id="input-file-id" type="file" [hidden]="true" />
<label for="input-file-id" class="scaffold-upload-label">{{'choose_file'| translation}}</label>